<template>
  <CBox>
    <OmtTypography
      as="p1"
      line-height="22px"
      mb="16px"
    >
      Precisamos de informações complementares para continuarmos a análise da solicitação de reembolso.
    </OmtTypography>

    <CFlex
      class="refund-audit-warning"
      backgroundColor="var(--colors-light-primary-light-gray)"
      borderRadius="8px"
      padding="11px 24px 10px 16px"
      min-height="99px"
      mb="24px"
    >
      <CBox flex="0 0 16px">
        <OmtIcons
          name="circle-exclamation"
          size="sm"
          color="var(--colors-light-support-warning)"
        />
      </CBox>
      <CBox ml="16px">
        <OmtTypography
          as="p2"
          class="refund-audit-warning__text"
        >
          <b>Importante</b>: O prazo para envio das informações é até <b>{{ dueDate }}</b> . Após essa data esta
          solicitação de reembolso será <b>automaticamente cancelada</b>.
        </OmtTypography>
      </CBox>
    </CFlex>

    <OmtTypography
      v-show="!!question.text"
      as="h2-bold"
      mb="20px"
    >
      {{ question.text }}
    </OmtTypography>

    <AuditRadioGroup
      v-if="question.options && question.options.length"
      hasDivider
      :values="question.options"
      :value.sync="selectedRadio"
      customValueKey="id"
    />
  </CBox>
</template>

<script>
import AuditRadioGroup from "./AuditRadioGroup.vue";

export default {
  components: {
    AuditRadioGroup
  },
  props: {
    question: {
      type: Object,
      default: () => ({
        text: "",
        options: []
      })
    },
    dueDate: String
  },
  data() {
    return {
      selectedRadio: null
    };
  },
  watch: {
    selectedRadio(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style scoped>
.refund-audit-warning__text {
  width: 270px;
  font-weight: 700 !important;
}
</style>
